// Assets
import NotFoundImage from '@/assets/svgs/not-found-logo.svg?react';

// Style
import './notFound.css';

const NotFound = () => (
  /* ******************************** RENDERING ******************************* */
  <div className='not-found fully'>
    <div className="not-found__box">
      <div className="not-found__logo">
        <NotFoundImage />
      </div>

      <h1 className='not-found__title'>404 Not Found</h1>
    </div>
  </div>
);
export default NotFound;
